import { useEffect, useState } from "react";

import { twMerge } from "tailwind-merge";

import { TextInput, type TextInputProps } from "./text-input";

export function isNumber(value: string) {
  return !isNaN(Number(value));
}

export interface NumberInputProps
  extends Omit<TextInputProps, "value" | "onChange"> {
  value: number | undefined;
  onChange: (value: number | undefined) => void;
}

export const NumberInput = ({
  className,
  value,
  onChange,
  ...props
}: NumberInputProps) => {
  const [localValue, setLocalValue] = useState(String(value));

  useEffect(() => {
    setLocalValue((value ?? "").toString());
  }, [value]);

  return (
    <TextInput
      className={twMerge("text-xs text-right font-mono", className)}
      value={localValue}
      onPaste={(e) => {
        e.preventDefault();
        const val = e.clipboardData.getData("text").replaceAll(",", "");

        if (isNumber(val)) {
          onChange?.(Number(val));
          setLocalValue(val);
        }
      }}
      onChange={(e) => {
        const val = e.target.value;

        if (!val) {
          onChange?.(undefined);
          setLocalValue("");
        } else if (val === "-") {
          setLocalValue(val);
        } else if (val.startsWith("+") || val.match(/^0\d+/)) {
          // do nothing
        } else if (isNumber(val)) {
          onChange?.(Number(val));
          setLocalValue(val);
        }
      }}
      {...props}
    />
  );
};
